"use strict";

import Vue from 'vue'
import VueFilterNumber from '@/vue/filters/vue-filter-number'
import EventBus from '@/vue/events/event-bus'
import allBetMixin from '@/vue/mixins/allBet'
import minibet from '@/vue/components/mini-bet'

import {
  mapGetters,
} from 'vuex'

Vue.component('oddOutright',{
  components: {
    minibet,
  },
  mixins: [allBetMixin],
  name:'oddOutright',
  template: `
    <div :id="getOddUniqueId(event)" class="odds" @click="onClickOdd($event);" :class="getClass(event, isNegative, isDiff)">
      <template v-if="checkOddValidation(event.t[team].od)">
        <span>
          <template v-if="sportMiniBet.allow && sportMiniBet.toggle && checkOTRMiniBetUnique(event, getOddUniqueId(event))">
            {{  getDecimalDisplay(betForm.odd) }}
          </template>
          <template v-else>
            {{  getDecimalDisplay(event.t[team].od) }}
          </template>
        </span>
      </template>
      <div class="odds-arrows-wrap">
        <div class="odds-icon odds-up"></div>
        <div class="odds-icon odds-down"></div>
      </div>
    </div>
  `,
  // <minibet v-if="sportMiniBet.allow && sportMiniBet.toggle && checkOTRMiniBetUnique(event, getOddUniqueId(event))"></minibet>
  props: {
    event: null,
    team: null,
  },
  computed: {
    ...mapGetters([
      'sportMiniBet',
    ]),
    betForm () {
      return this.$store.getters.betForm[0]
    },
  },
  watch: {
    'event': {
      handler(val, oldVal) {
        if(typeof val != 'undefined' ){
          this.classNegative(val.t[this.team].od)
          if(oldVal && !this.refreshOdd){
            this.refreshOdd = false
            this.diffOdds(val.t[this.team].od, oldVal.t[this.team].od)
          } else if (this.refreshOdd) {
            this.refreshOdd = false
            this.isDiff = false
          } else if (!oldVal) { //when not same template
            this.refreshOdd = true
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isNegative: false,
      isDiff: false,
      refreshOdd: false,
    }
  },
  methods: {
    getClass(windowEvent, isNeg, isDif) {
      var classStr = ''
      var classMini = ''
      // if(this.sportMiniBet.allow && this.sportMiniBet.toggle && this.checkOTRMiniBetUnique(windowEvent, this.getOddUniqueId(windowEvent))){
      //   classMini = ' selected panelActive'
      //   if(this.sportMiniBet.rightside){
      //     classMini = ' selected panelActive-bottomRight'
      //   }
      //   if(this.betForm.oddChg){
      //     classStr = 'indicator' 
      //   }
      // } 

      // else if (this.isNegative) {
      //   classStr = 'indicatorDown'// ngve: isNegative, diff: isDiff
      // } else if (this.isDiff) {
      //   classStr = 'indicatorUp'
      // }
      return classStr + classMini
    },
    onClickOdd (windowEvent) {
      EventBus.$emit('returnBetTab')
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return
      }
      var betForm = {
        eveid: this.event.eveid,
        title: this.$store.getters.selectedBettype.sprtTitleLang ,
        league: this.event.lgecapt +" - "+this.event.evecapt,
        sprtid: this.event.sptid,
        eveid: this.event.eveid,
        plyType: '0', //'1'
        betType: this.otrBetType,
        tbet: this.event.t[this.team].tid,
        tbetcapt: this.event.t[this.team].tcapt,
        tbetid: this.event.t[this.team].tid,
        odd: this.event.t[this.team].od,
        rbscoa: 0,
        rbscob: 0,
        hdp: '0',
        dual: 'a', //1x2 only a
        fav: '0',
        eventObj: this.event,
        uniqueId: this.event.eveid + '1' + this.otrBetType + this.team + this.event.t[this.team].tid,
      }
 
      if(this.event.rb) {
        if(this.event.rbinfo) {
          betForm.rbscoa = this.event.rbinfo.scoa
          betForm.rbscob = this.event.rbinfo.scob
        }
      }

      if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {
 //      betForm.title = this.$store.getters.selectedBettype.sprtTitleLang + ' - ' + this.$store.getters.market.earlyMarket.betLang
      }

      // Check if current sel has selected, if true remove else add
      var indexx = _.findIndex(this.$store.getters.betForm, {
        'eveid': this.event.eveid,
        'plyType': '0', //'1'
        'betType': this.otrBetType,
        'dual': 'a',
        'tbet': this.event.t[this.team].tid,
      });

      if(indexx > -1){
        var obj = {eveid: this.event.eveid}
        if(this.$store.getters.isBetCombo){
          obj = {clearType: '3', index: indexx}
        }
        this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
        this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

        this.$store.dispatch("removeMatch", {
          // eveid: this.event.eveid,
          data: obj,
          callback: (() => {
            this.$store.commit("PARLAY_SELECTED", {
              remove: true,
              eveid: this.event.eveid,
            });
            var MID = $(windowEvent.target).closest('div[id]')[0].id
            // document.getElementById(MID).parentElement.classList.remove('active')
            $("[id="+MID+"]").closest('.c-bet-item.active').removeClass('active')
            if (this.$store.getters.betForm.length <= 0) {
              this.$store.commit("OPEN_BETFORM", false)
              this.$store.commit('ODD_SELECTED', false)
              this.$store.commit("SHOW_BETFORM_MENU", false);
              this.$store.commit('SELECTED_TAB', 'betTab')
              return;
            }
            this.$store.dispatch("getBettingInfo", {
              callback: ((res) => {
                this.$store.commit("SPORT_MAPPING_BETTING", {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBettingList: this.$store.getters.betForm,
                });
                // this.refreshTimer();
                // this.isReloading = false;
              }).bind(this),
            });
          }).bind(this),
        });
      } else {
        //betcombo validate max betcombo wager
        if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length==this.betComboMax){
          var chkRes = this.checkBetComboMax(betForm)
          if(chkRes){
            return
          }
        }

        this.$store.dispatch('getLatestInfo', {
          data: betForm,
          callback: ((res)=> {
            if(res.SYSTEM_DATA.status != 'FAIL') {
              if(this.$store.getters.sportMiniBet.toggle){
                EventBus.$emit('expandMini')
              }
              this.oddSelectHighlight(windowEvent, betForm)

              if(this.$store.getters.miniNormal==1){
                this.showMiniBet(windowEvent);
              }
              if(!this.$store.getters.isBetCombo){
                this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                EventBus.$emit('resetKeyboard')
              }

              this.$store.commit('OPEN_BETFORM', true)
              this.$store.commit('ODD_SELECTED', true)
              // this.$store.commit('SELECTED_BETTAB', true)
              this.$store.commit('BET_FORM', {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBetData: betForm
              })
            }
          }).bind(this)
        })
      }
    },
    classNegative (val, oldVal) {
      this.isNegative = val < 0 ? true : false
    },
    diffOdds (val, oldVal) {
      this.isDiff = val != oldVal ? true : false
    },
    getOddUniqueClass (event) {
      var classStr = ''
      if(this.plyType == '2') {
        classStr += 'ht '
      }
      classStr += this.getOddUniqueId(event)
      return classStr
    },
    getOddUniqueId(event) {
      return event.eveid + '1' + this.otrBetType + this.team + this.event.t[this.team].tid
    },
  },
  beforeMount() {
    EventBus.$on(['refreshOdd'], ((params) => {
      if (params == false) {
        this.refreshOdd = false // change market, change page, change parlayEarlyDate
      } else {
        this.refreshOdd = true // change odd type, refresh button
      }
    }).bind(this))
  },
  mounted(){
    this.$store.getters.betForm.forEach(value => {
      var MID = value.uniqueId;
      $("[id="+MID+"]").closest('.c-bet-item').addClass('active')
    })
  }
})



// WEBPACK FOOTER //
// ./resources/wob/vue/components/odd-outright.js